/*
 * Jira Ticket:
 * Created Date: Tue, 10th Mar 2020, 12:20:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  DialogTitle as MuiDialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import parse from 'html-react-parser';
import { dialogStyles } from 'resources/auth/styles';

const DialogTitle = props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      <Typography>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const TermsAndConditionsDialog = withStyles(dialogStyles)(props => {
  const {
    dialogOpen,
    setDialogState,
    handleAcceptTCs,
    classes,
    termsAndConditions,
  } = props;
  const translate = useTranslate();
  const [isLoading, setLoading] = useState(false);

  return (
    <Dialog
      onClose={() => setDialogState(false)}
      aria-labelledby="customized-dialog-title"
      open={dialogOpen}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={() => setDialogState(false)}
        classes={classes}
      >
        <strong>{translate('authentication.termsAndConditions.title')}</strong>
      </DialogTitle>
      <DialogContent className={classes.dialogContentRoot} dividers>
        {termsAndConditions && (
          <div className={classes.termsWindow}>{parse(termsAndConditions)}</div>
        )}
      </DialogContent>
      <DialogActions className={classes.dialogActionsRoot}>
        <Button
          onClick={() => handleAcceptTCs(setLoading)}
          className={classes.loadingIndicator}
        >
          {isLoading ? (
            <CircularProgress
              size={25}
              thickness={3}
              className={classes.loadingIndicator}
            />
          ) : (
            translate('authentication.termsAndConditions.submit')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default TermsAndConditionsDialog;
